import type { usePaginatedProductDropdown } from '@/hooks/usePaginatedProductDropdown';
import type { ProductLookupItem } from '@/hooks/usePaginatedProductDropdown';

type ProductDropdown = ReturnType<typeof usePaginatedProductDropdown>;

/** The catalogue props `ProductPicker` and the edit product grid take. */
export interface PickerCatalogProps {
  options: ProductLookupItem[];
  catalogTotalCount: number;
  loading: boolean;
  search: string;
  searchInputKey: number;
  onSearch: (value: string) => void;
  onScroll: (e: React.UIEvent<HTMLDivElement>) => void;
}

/** Maps the paginated product dropdown onto the picker's catalogue props, so every picker reads the catalogue the same way. */
export function pickerCatalogProps(
  dropdown: ProductDropdown
): PickerCatalogProps {
  return {
    options: dropdown.products,
    catalogTotalCount: dropdown.catalogTotalCount,
    loading: dropdown.loading,
    search: dropdown.search,
    searchInputKey: dropdown.searchInputKey,
    onSearch: dropdown.setSearch,
    onScroll: dropdown.handlePopupScroll,
  };
}
